import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const storeGRDataCookie = () => {
	const expiry = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000); // Expiry date as a Date object

	const facilityCode = new URLSearchParams(window.location.search).get('fc');
	const rwgToken = new URLSearchParams(window.location.search).get('rwg_token');

	if (facilityCode && cookies.get('cc-facility-code') !== facilityCode) {
		cookies.set('cc-facility-code', facilityCode, { expires: expiry });
	}

	if (rwgToken && cookies.get('rwg_token') !== rwgToken) {
		cookies.set('rwg_token', rwgToken, { expires: expiry });
	}
};
